let prefix = '/api/sap/taxes';
function getTaxes(validForAR) {
    return window.axios.get(prefix+'/index/'+validForAR)
}
export default {
    getTaxes,
}